/**
 * StdlibENOrbStdlibRoute
 *
 * Page component for StdlibENOrbStdlibRoute
 * Path: /stdlib
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { StdlibENOrbStdlibPageView as __StdlibENOrbStdlibPageView } from '@/components/traits/StdlibENOrbStdlibPageView';
import { StdlibENOrbStdlibAnalyticsView as __StdlibENOrbStdlibAnalyticsView } from '@/components/traits/StdlibENOrbStdlibAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface StdlibENOrbStdlibRouteProps {
  // Add any page-level props here
}

export function StdlibENOrbStdlibRoute(_props: StdlibENOrbStdlibRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-stdlib:meta.title"],"description":["i18n/t","std-orb-stdlib:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/stdlib"},{"locale":"ar","path":"/ar/stdlib"},{"locale":"sl","path":"/sl/stdlib"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__StdlibENOrbStdlibPageView config={{ initPayload: __navState }} />
          <__StdlibENOrbStdlibAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default StdlibENOrbStdlibRoute;
